<template>
  <div>

    <p>Tryck på den typen av enhet du antingen vill lägga till eller ta bort här nedanför så kommer du att skickas vidare. För att ta bort en Z-Wave enhet kan du exkludera den längst ner.</p>
    
    <div v-if="!$root.connected">
      <div class="info"><strong>OBS!</strong> Du är inte ansluten till din Nexa Bridge vilket gör att du inte kan lägga till vissa typer av enheter. Ladda om sidan för att försöka ansluta igen.</div>
      <hr class="space">
    </div>
    
    <h3>Lägg till...</h3>
    
    <table>
      <tbody>
        <tr v-for="item in items" v-if="item.show" @click="go(item)" :style="stylee(item)">
          <td>{{ item.name }}</td>
          <td align="right"><img v-if="!item.disabled" src="../assets/add.png" width="20"></td>
        </tr>
      </tbody>
    </table>
    
    <hr class="space">
    
    <h3 v-if="$root.connected">Ta bort</h3>
      <table v-if="$root.connected">
      <tbody>
        <tr @click="go({'id': 'remove_zwave'})">
          <td>Exkludera Z-Wave enhet</td>
          <td align="right"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
    import { VueTabs, VTab } from 'vue-nav-tabs'

  export default {
    name: 'HelloWorld',
    components: {
      VueTabs, VTab
    },
    data () {
      return {}
    },
    created () {},
    methods: {
      go (item) {
        if (item.disabled) {
          return false
        }
        
        let obj = {
          name: item.id
        }
  
        if ('query' in item) {
          obj.query = item.query
        }
  
        this.$router.push(obj)
      },
      
      stylee (item) {
        return {
          'color': (item.disabled ? '#d2d2d2' : '#000'),
          'cursor': (item.disabled ? 'auto' : 'pointer')
        }
      }
    },
    
    computed: {
      supportForNXT () {
        return 'systemType' in this.$root.data.info && this.$root.data.info.systemType !== 'Bridge1'
      }, 

      items () {
        return [
          { id: 'add_systemnexa', name: 'System Nexa', items: [{ name: 'Mottagare på/av'}], show: true },
          { id: 'add_nxt', name: 'NXT by NEXA', disabled: !this.$root.connected, show: this.supportForNXT },
          { id: 'add_firesafety', name: 'Fire & Safety', disabled: !this.$root.connected, show: true },
          { id: 'add_zwave', query: { secure: false }, name: 'Z-Wave', disabled: !this.$root.connected, show: true },
          { id: 'add_zwave', query: { secure: true }, name: 'Z-Wave secure', disabled: !this.$root.connected, show: true },
          { id: 'add_virtuell', name: 'Virtuell enhet', show: true }
        ]
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/add.vue